import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import ResponsiveTabs from '@components/@core/ResponsiveTabs';
import Tab from '@components/@core/Tab';
import EditDropdown from '@components/EditDropdown';
import VendorActions from '~/actions/vendor';
import { CONNECTION_MOBILE_TABLIST } from '~/services/constants';
import People from './People';
import Companies from './Companies';
import ReceivedRequests from './ReceivedRequests';
import SentRequests from './SentRequests';

const ConnectionsAdmin = ({ business }) => {
    const dispatch = useDispatch();

    const company = business.vrs;
    const connections = business.vrs?.connections;
    if (!connections) return null;

    const [active, setActive] = useState(CONNECTION_MOBILE_TABLIST[0].id);
    const [search, setSearch] = useState('');
    const [searchRes, setSearchRes] = useState(null);

    const handleDropdown = (e) => {};

    const handleSearch = (e) => {
        setSearch(e);
        if (e === '') {
            setSearchRes(null);
        } else {
            dispatch(VendorActions.globalsearchRequest({ search: e, verbatim: 1 }, null, null, handleSearchResult));
        }
    };

    const handleSearchResult = (e) => {
        setSearchRes(e);
    };

    const handleSelectTab = (e) => {
        setActive(e.id);
        setSearch('');
        setSearchRes(null);
    };

    return (
        <ErrorBoundary className="company-connections-admin">
            <div className="connections-header p-3">
                <p className="dsl-b22 bold my-2">{`${company.name} Connections`}</p>
                <EditDropdown options={['Edit']} onChange={handleDropdown} />
            </div>
            <ResponsiveTabs className="p-2" active={active} data={CONNECTION_MOBILE_TABLIST} onTab={handleSelectTab} />
            <Tab eventKey="people" active={active}>
                <People company={company} connections={connections.active_user_connections} search={search} users={searchRes?.users || []} onSearch={handleSearch} />
            </Tab>
            <Tab eventKey="companies" active={active}>
                <Companies company={company} connections={connections.active_company_connections} search={search} companies={searchRes?.businesses || []} onSearch={handleSearch} />
            </Tab>
            <Tab eventKey="received" active={active}>
                <ReceivedRequests company={company} connections={connections.pending_connections_received} />
            </Tab>
            <Tab eventKey="sent" active={active}>
                <SentRequests company={company} connections={connections.pending_connections_sent} />
            </Tab>
        </ErrorBoundary>
    );
};

ConnectionsAdmin.propTypes = {
    business: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        vrs: PropTypes.shape({
            id: PropTypes.number,
            connections: PropTypes.shape({
                active_company_connections: PropTypes.array,
                active_user_connections: PropTypes.array,
                follower_companies: PropTypes.array,
                follower_users: PropTypes.array,
                following_companies: PropTypes.array,
                following_users: PropTypes.array,
                pending_connections_received: PropTypes.array,
                pending_connections_sent: PropTypes.array,
            }),
        }),
    }),
};

ConnectionsAdmin.defaultProps = {
    business: {
        id: 0,
        name: '',
        vrs: {
            id: 0,
            connections: {
                active_company_connections: [],
                active_user_connections: [],
                follower_companies: [],
                follower_users: [],
                following_companies: [],
                following_users: [],
                pending_connections_received: [],
                pending_connections_sent: [],
            },
        },
    },
};

export default ConnectionsAdmin;
